import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import PreaConfigurations from '../event-notification/PreaConfigurations';

type FacilityAlertsTabProps = {
  facility: Facility;
};

const FacilityAlertsTab: React.FC<FacilityAlertsTabProps> = ({ facility }) => {
  return (
    <div className="jarviswidget jarviswidget-color-blueDark">
      <div className="content">
        <PreaConfigurations facility={facility} />
      </div>
    </div>
  );
};

export default FacilityAlertsTab;
